import { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { Redirect, Route, BrowserRouter, Switch } from 'react-router-dom';
import {Provider} from "react-redux";
import { ThemeProvider } from 'styled-components';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import Helmet from 'react-helmet';
import themes from './config/themes';
import AppLocale from './languageProvider';
import config, {
  getCurrentLanguage
} from './containers/LanguageSwitcher/config';



import createHistory from 'history/createBrowserHistory';


import Admin from './Admin/Admin';
import Callback from './components/Callback/Callback';
import Auth from './Auth/Auth';
import Home from './containers/Home';
import Ping from './containers/Ping/Ping';
// import EditCampaign from './containers/EditCampaign';
import MyAccount from './containers/MyAccount';
import MyBilling from './containers/MyBilling';
import OrderReview from './containers/OrderReview';
import OrderSuccess from './containers/OrderSuccess';
import CampaignList from './containers/CampaignList';
import Profile from './containers/Profile';
import AddCampaign from './containers/AddCampaign';
import AddCampaignForm from './containers/AddCampaignForm';
import Dashboard from './containers/Dashboard';
import AsoAnalytic from './containers/AsoAnalytic';
import App from './containers/App/App';
import Landing from  './containers/Landing';
import Header from  './components/Header';
import Footer from  './components/Footer';

import { themeConfig } from './config';
import DashAppHolder from './dashAppStyle';
import { persistStore } from 'redux-persist-immutable';

const currentAppLocale =
  AppLocale[getCurrentLanguage(config.defaultLanguage || 'english').locale];

const auth = new Auth();

const handleAuthentication = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.handleAuthentication();
  }
}
import './global-styles';



const initialState = {};
// import configureStore from './configureStore';
import configureStore from './redux/store';
const history = createHistory();
const store  = configureStore(initialState, history);
// import { store, history } from './redux/store';

import AppHeader from './AppHeader';

export default class Preloader extends Component {
  constructor() {
    super()
    this.state = { rehydrated: false }
  }

  componentWillMount(){
    persistStore(store, { whitelist: ['ItunesSearch']}, () => {
      this.setState({ rehydrated: true });
    })
  }

  render() {

    if(!this.state.rehydrated){
      return <div>
         <Helmet
              title="Project X"
            
              description="Best platform for Apple Search Ads">
                <meta charSet="utf-8" />
                <title>Project X</title>
                <link rel="canonical" href="http://project-x.gogochart.com/" />
                <meta name="description" content="Best platform for Apple Search Ads" />
            </Helmet>
        </div>;
    }
    return (
    <LocaleProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
      <ThemeProvider theme={themes[themeConfig.theme]}>
      <DashAppHolder>
      <Provider store={store}>
        <BrowserRouter history={history}>
          <div>
            <Helmet
              title="Project X"
            
              description="Best platform for Apple Search Ads">
                <meta charSet="utf-8" />
                <title>Project X</title>
                <link rel="canonical" href="http://project-x.gogochart.com/" />
                <meta name="description" content="Best platform for Apple Search Ads" />
            </Helmet>

            <Switch>
              {/* header */}
              <Route exact path="/" render={(props) => <Landing auth={auth} {...props}/>} />
              <Route path="/aso" render={(props) => null} />
              <Route path="/home" render={(props) => null} />
              <Route path="/payment/success" render={(props) => null} />
              <Route path="/campaign" render={(props) => null} />

              <Route path="/" render={(props) => <Header auth={auth} {...props} /> } />
              {/* <Route path="/" render={(props) => <AppHeader auth={auth} {...props} />} /> */}
            </Switch>

            <Switch>
              <Route path="/home" render={(props) => <Home auth={auth} {...props} />} />

              <Route path="/profile" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Profile auth={auth} {...props} />
                )
              )} />
              <Route path="/ping" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Ping auth={auth} {...props} />
                )
              )} />

              <Route exact path="/addCampaign" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <AddCampaign auth={auth} {...props} />
                )
              )} />

              <Route path="/addCampaign/appId/:appId" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <AddCampaignForm auth={auth} {...props} />
                )
              )} />

               <Route path="/addCampaign/confirm" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <OrderReview auth={auth} {...props} />
                )
              )} />

              <Route path="/payment/success" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <OrderSuccess auth={auth} {...props} />
                )
              )} />
              <Route path="/aso/:appId" render={(props) => <AsoAnalytic auth={auth} {...props} />} />
              <Route path="/campaign/:appId/aso" render={(props) => <AsoAnalytic auth={auth} {...props} />} />

              <Route path="/campaign/" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <CampaignList auth={auth} {...props} />
                )
              )} />

              <Route path="/campaign/:campaignId" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Dashboard auth={auth} {...props} />
                )
              )} />
             

             <Route path="/dashboard/:appId/region/:region/pcid/:pcid/dcid/:dcid" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Dashboard auth={auth} {...props} />
                )
              )} />

                <Route path="/dashboard/:appId" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Dashboard auth={auth} {...props} />
                )
              )} />
              <Route path="/dashboard" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Dashboard auth={auth} {...props} />
                )
              )} />

              <Route exact path="/campaign" render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <Dashboard auth={auth} {...props} />
                )
              )} />

              <Route path="/admin" render={(props) => (
                !auth.isAuthenticated() || !auth.userHasScopes(['write:messages']) ? (
                  <Redirect to="/"/>
                ) : (
                  <Admin auth={auth} {...props} />
                )
              )} />
             
              

              <Route path="/me/account"  render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <MyAccount auth={auth} {...props} />
                )
              )} />
              <Route path="/me/billing"  render={(props) => (
                !auth.isAuthenticated() ? (
                  <Redirect to="/"/>
                ) : (
                  <MyBilling auth={auth} {...props} />
                )
              )} />

              <Route path="/callback" render={(props) => {
                handleAuthentication(props);
                return <Callback {...props} /> 
              }}/>        
              {/* <Route path="*" component={NotFound} /> */}
            </Switch>

            <Switch>
              {/* footer */}
              <Route exact path="/" render={ null }/>
              <Route path="/aso" render={(props) => null} />
              <Route path="/payment/success" render={(props) => null} />
              <Route path="/campaign" render={(props) => null} />
              
              <Route path="/" render={(props) => <Footer auth={auth} {...props} /> } />
            </Switch>
          </div>
        </BrowserRouter>
        </Provider>
        </DashAppHolder>
      </ThemeProvider>
      </IntlProvider>
  </LocaleProvider>
    );
  }
}
ReactDOM.render( <Preloader/>, document.getElementById('root') );



// WEBPACK FOOTER //
// ./src/index.js